module.exports = new __parcel__URL__("crash_11.cd2e80a9.mp3").toString();